<template>
    <b-table
            class="position-relative bg-white"
            style="min-height: 350px"
            responsive
            :items="fetchedData"
            :fields="tableColumns"
            :sort-by.sync="sortBy"
            :sort-desc.sync="isSortDirDesc"
            :busy="dataLoading"
            primary-key="id"
            show-empty
            @sort-changed="(ctx)=> $emit('sort-changed', ctx)"
            hover
            selectable
            select-mode="multi"
            @row-selected="(ctx)=> $emit('selected', ctx)"

    >

        <template slot="empty">
          <no-data></no-data>
        </template>
        <template #cell()="data">
          <!-- custom cell representation-->
          <slot name="tableCellCustomRepresentations" v-bind="data">
              <!-- base cell representation with checking on html preview-->
              <span v-if="!data.field.escaped" v-html="data.value"></span>
              <span v-else>{{data.value}}</span>

          </slot>


        </template>
        <template slot="table-busy">
            <div class="text-center my-5">
                <b-spinner
                        class="mr-1 align-middle"
                        variant="primary"
                />
                 <strong>Загрузка данных ...</strong>
            </div>
        </template>
        <template #cell(actions)="data">
              <b-dropdown
                variant="link"
                no-caret
                left
              >
                <template #button-content>
                  <feather-icon
                    icon="MoreVerticalIcon"
                    size="16"
                    class="align-middle text-body"
                  />
                </template>
                  <b-dropdown-item v-for="action in data.field.actions" @click="action.action(data.item)">
                      <feather-icon icon="FileTextIcon" />
                      <span class="align-middle ml-50">{{action.label}}</span>
                  </b-dropdown-item>
              </b-dropdown>
          </template>

    </b-table>
</template>

<script>


  import { BTable, BSpinner, BButton, BDropdown, BDropdownItem} from 'bootstrap-vue'
  import NoData from '../components/NoData.vue'


  export default {


      components: {
          BTable,
          BSpinner,
          BButton,
          BDropdown,
          BDropdownItem,

          NoData
      },

      props: {
          sortBy: {
            type: String,
            default: "uid",
            required: false,
          },
          isSortDirDesc: {
            type: Boolean,
            default: true,
            required: false,
          },
          fetchedData: {
            type: Array,
            default: () => [],
            required: false,
          },
          tableColumns: {
            type: Array,
            default: () => [],
            required: false,
          },
          dataLoading: {
            type: Boolean,
            default: false,
            required: false
          },
      },
  }
</script>
